// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3vZ8a","tab":"ProcedureTabs_tab__nCOyd"};